import { render, staticRenderFns } from "./ResourceContainer.vue?vue&type=template&id=4e6d49cc&scoped=true"
import script from "./ResourceContainer.vue?vue&type=script&lang=js"
export * from "./ResourceContainer.vue?vue&type=script&lang=js"
import style0 from "./ResourceContainer.vue?vue&type=style&index=0&id=4e6d49cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6d49cc",
  null
  
)

export default component.exports